import "./Login.css";
import { GoogleLogin, CredentialResponse } from "@react-oauth/google";
import { useNavigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

export const COMPANY_CAPTION = "Digital | Cloud | Data | Cybersecurity";
export const IMAGE_URL =
  "https://static.wixstatic.com/media/bd5ec7_5eb8282503b74bbdbf0c66ab1256d752~mv2.png/v1/fill/w_272,h_84,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/logo%20gray.png";
export const TOKEN = "token-latest";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();

  interface GoogleUser {
    name: string;
    email: string;
    picture: string;
  }
  const from = (location.state as { from?: string })?.from || "/home";

  const saveLoginInfo = async (tokenPayload: any) => {
   try {
      await fetch(`${(import.meta as any).env.VITE_API_URL}/login/save_login_info`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(tokenPayload)
      });
    }
    catch (err) {
      console.error('Login failed:', err);
    }
}

  const onGoogleLoginSuccess = (data: CredentialResponse) => {
    if (!data?.credential) return;
    const decoded: GoogleUser = jwtDecode(data.credential);
    saveLoginInfo({...decoded, app_name: "agent-frontend"} );
    localStorage.setItem("user", JSON.stringify(decoded));
    localStorage.setItem(TOKEN, data.credential);
    navigate(from, { replace: true });
  };

  return (
    <div className="login-wrapper">
      <div className="login-left">
        <img src={IMAGE_URL} className="img-fluid" alt="Logo" />
        <p className="login-caption">{COMPANY_CAPTION}</p>
      </div>
      <div className="login-right">
        <div className="google-btn-wrapper">
          <GoogleLogin
            onSuccess={onGoogleLoginSuccess}
            onError={() => console.error("Login Failed")}
          />
        </div>
      </div>
    </div>
  );
};

export default Login;